export type GroundClampInput={id:string;y:number;footY?:number;velocityY?:number;groundY?:number;height?:number}
export type GroundClampResult=GroundClampInput&{correctedY:number;penetration:number;residualPenetration:number;grounded:boolean;reason:string}
export function clampFighterToGround(input:GroundClampInput):GroundClampResult{
 const ground=input.groundY??0
 const foot=input.footY??input.y-(input.height??2)*.5
 const penetration=Math.max(0,ground-foot)
 const correctedY=input.y+penetration
 return{...input,correctedY,penetration,residualPenetration:Math.max(0,ground-(foot+penetration)),grounded:penetration>0||Math.abs(foot-ground)<.035,reason:penetration>0?'ground-penetration-corrected':'stable'}
}
export function assertNoGroundPenetration(input:GroundClampInput){
 const r=clampFighterToGround(input)
 if(r.residualPenetration>.018)throw new Error('Fighter ground penetration exceeds clamp tolerance: '+input.id+' '+r.penetration.toFixed(3))
 return r
}
